/**
 * Job Description Section Component
 * Displays the job description text
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface JobDescriptionSectionProps {
  description: string | null | undefined;
}

export const JobDescriptionSection: React.FC<JobDescriptionSectionProps> = ({ description }) => {
  if (!description) return null;

  return (
    <div className="my-4">
      <h3 className="font-bold text-lg text-gray-900 dark:text-white mb-2">
        <FormattedMessage id="jobDetailPage.description" defaultMessage="Job Description" description="Section heading for full job description text" />
      </h3>
      <p className="text-gray-700 dark:text-gray-200 text-base whitespace-pre-line">{description}</p>
    </div>
  );
};
